import React, {createContext, useState} from 'react';
import PropTypes from 'prop-types';

export const OrganizationContext = createContext({});

export const Provider = (props) => {
  const {children} = props;

  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const [reloading, setReloading] = useState(false);

  const organizationContext = {
    selectedOrganization,
    setSelectedOrganization,
    reloading,
    setReloading,
  };

  return (
    <OrganizationContext.Provider value={organizationContext}>
      {children}
    </OrganizationContext.Provider>
  );
};

export const {Consumer} = OrganizationContext;

Provider.propTypes = {
  children: PropTypes.any,
};
